import axios from "axios";

export const getLaporanArusKas = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/laporanJurnal/arusKas`,
    formData,
    {
      withCredentials: true,
    }
  );
};
